export default __webpack_public_path__ + "static/media/AutoGravity-1.7a904b75.jpg";